import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import { API_ENDPOINTS, DEFAULT_PAGE_START } from '../Utils/constants'

export default class TaskGroupStore extends FetchBase {
  @observable taskGroupFoldersWithTaskLoader = false
  @observable taskGroupFoldersWithTaskList = []
  @observable taskGroupsListByFId = []

  @observable taskGroupFoldersSearchText = ''
  @observable taskGroupFoldersLoader = false
  @observable taskGroupFoldersCurrentPage = DEFAULT_PAGE_START
  @observable taskGroupFoldersList = []
  @observable taskGroupFoldersTotal = 0
  @observable taskGroupFolderActionLoader = false
  @observable moveTaskGroupByFIdLoader = false
  @observable taskGroupFoldersDropdownList = []

  @observable taskGroups = []
  @observable taskTypes = []
  @observable taskSubTypes = []

  @observable taskGroupLoader = false
  @observable taskTypesLoader = false
  @observable taskSubTypesLoader = false

  @observable taskGroupAddLoader = false
  @observable taskGroupUpdateLoader = false
  @observable taskGroupDeleteLoader = false

  @observable taskTypesAddLoader = false
  @observable taskTypesUpdateLoader = false
  @observable taskTypesDeleteLoader = false

  @observable taskSubTypesAddLoader = false
  @observable taskSubTypesUpdateLoader = false
  @observable taskSubTypesDeleteLoader = false

  @observable taskGroupSearchText = ''

  @action.bound
  taskGroupFoldersWithGroupDropdown = async (signal) => {
    try {
      this.taskGroupFoldersWithTaskLoader = true
      let response = await this.post(
        API_ENDPOINTS.GET_DROPDOWN_TASKGROUP_FOLDER,
        {},
        signal
      )
      if (response.status) {
        this.taskGroupFoldersWithTaskList = response.data
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskGroupFoldersWithTaskLoader = false
    }
  }

  @action.bound
  taskGroupFoldersDropdown = async (signal) => {
    try {
      this.taskGroupFoldersWithTaskLoader = true
      let response = await this.get(
        API_ENDPOINTS.FOLDER_TASK_GROUP,
        {
          pageLimit: 0,
        },
        signal
      )
      if (response.status) {
        this.taskGroupFoldersDropdownList = response.data?.taskFolders
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskGroupFoldersWithTaskLoader = false
    }
  }

  @action.bound
  getTaskGroupByFId = (fId, taskGroupFoldersList) => {
    if (fId) {
      for (let taskGroupFromFolder of taskGroupFoldersList) {
        if (taskGroupFromFolder?.id === fId) {
          this.taskGroupsListByFId = taskGroupFromFolder
          return taskGroupFromFolder?.taskGroups
        }
      }
    } else {
      this.taskGroupsListByFId = []
    }
  }

  resetTaskPrefilledFromTaskGroup = () => {
    this.taskGroupsListByFId = []
  }

  @action.bound
  setTaskGroupFoldersSearchText = (value = '') => {
    this.taskGroupFoldersSearchText = value
  }

  @action.bound
  setTaskGroupFolderCurrentPage = (page = DEFAULT_PAGE_START) => {
    this.taskGroupFoldersCurrentPage = page
  }

  @action.bound
  getTaskGroupFolders = async (signal) => {
    try {
      this.taskGroupFoldersLoader = true
      let options = {}
      this.taskGroupFoldersSearchText &&
        (options['search'] = this.taskGroupFoldersSearchText)
      let response = await this.get(
        API_ENDPOINTS.FOLDER_TASK_GROUP,
        {
          pageNo: Math.max(this.taskGroupFoldersCurrentPage - 1, 0),
          ...options,
        },
        signal
      )
      if (response.status) {
        this.taskGroupFoldersList = response?.data?.taskFolders
        this.taskGroupFoldersTotal = response?.data?.total || 0
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskGroupFoldersLoader = false
    }
  }

  @action.bound
  addTaskGroupFolder = async (values) => {
    try {
      let response = await this.post(
        API_ENDPOINTS.FOLDER_ADD_TASK_GROUP,
        values
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  addTaskGroupFolderLocally = async (values) => {
    this.taskGroupFoldersList = [values, ...this.taskGroupFoldersList]
    if (this.taskGroupFoldersList.length > 10) {
      this.taskGroupFoldersList.pop()
    }
    this.taskGroupFoldersTotal++
  }

  @action.bound
  updateTaskGroupFolder = async (values) => {
    try {
      this.taskGroupFolderActionLoader = true
      let response = await this.post(
        API_ENDPOINTS.FOLDER_UPDATE_TASK_GROUP,
        values
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskGroupFolderActionLoader = false
    }
  }

  @action.bound
  updateTaskGroupFolderLocally = async (id, values) => {
    this.taskGroupFoldersList = (this.taskGroupFoldersList || []).map(
      (folder) => {
        if (folder.id === id) {
          return values
        } else {
          return folder
        }
      }
    )
  }

  @action.bound
  deleteTaskFolderFolder = async (data = {}) => {
    try {
      this.taskGroupFolderActionLoader = true
      let response = await this.post(
        API_ENDPOINTS.FOLDER_DELETE_TASK_GROUP,
        data
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskGroupFolderActionLoader = false
    }
  }

  @action.bound
  moveTaskGroupByFolderId = async (folderId = undefined, data = {}) => {
    try {
      let options = data
      this.moveTaskGroupByFIdLoader = true
      options['taskGroupFolderId'] = folderId
      let response = await this.post(API_ENDPOINTS.UPDATE_TASK_GROUPS, options)
      if (response.status) {
        return [true, response.status]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.moveTaskGroupByFIdLoader = false
    }
  }

  // End folder features

  @action.bound
  setTaskGroupSearchText = (value = '') => {
    this.taskGroupSearchText = value
  }

  @action.bound
  getFiltersForTaskGroups = () => {
    let temp = {}
    this.taskGroupSearchText && (temp['search'] = this.taskGroupSearchText)
    temp['pageLimit'] = 0
    return temp
  }

  @action.bound
  getTaskGroups = async (taskGroupFolderId = undefined, signal) => {
    try {
      this.taskGroupLoader = true
      let filters = this.getFiltersForTaskGroups() || {}
      filters['taskGroupFolderId'] = taskGroupFolderId
      let response = await this.get(
        API_ENDPOINTS.GET_TASK_GROUPS_LIST_ADMIN,
        {
          ...filters,
        },
        signal
      )
      if (response.status) {
        this.taskGroups = response.data?.rows
        return [true, response.data?.rows]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskGroupLoader = false
    }
  }

  @action.bound
  getTaskGroupByIdLocally = (id) => {
    return (this.taskGroups || []).find((taskGroup) => taskGroup?.id === id)
  }

  @action.bound
  addTaskGroupLocally = (value) => {
    this.taskGroups = [...this.taskGroups, value]
  }

  @action.bound
  addTaskGroup = async (values) => {
    try {
      this.taskGroupAddLoader = true
      let response = await this.post(API_ENDPOINTS.ADD_TASK_GROUPS, values)
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskGroupAddLoader = false
    }
  }

  @action.bound
  updateTaskGroupLocally = (value) => {
    this.taskGroups = (this.taskGroups || []).map((taskGroup) => {
      if (taskGroup?.id === value?.id) {
        return value
      }
      return taskGroup
    })
  }

  @action.bound
  updateTaskGroup = async (id, values) => {
    try {
      this.taskGroupUpdateLoader = true
      let response = await this.post(API_ENDPOINTS.UPDATE_TASK_GROUPS, {
        id: Number(id),
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskGroupUpdateLoader = false
    }
  }

  @action.bound
  deleteTaskGroupLocally = (id) => {
    this.taskGroups = (this.taskGroups || []).filter((taskGroup) => {
      return taskGroup?.id !== id
    })
  }

  @action.bound
  deleteTaskGroup = async (id) => {
    try {
      this.taskGroupDeleteLoader = true
      let response = await this.post(API_ENDPOINTS.DELETE_TASK_GROUPS, {
        id,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskGroupDeleteLoader = false
    }
  }

  @action.bound
  getTaskTypeByIdLocally = (id) => {
    return (this.taskTypes || []).find((taskType) => taskType?.id === id)
  }

  @action.bound
  getTaskTypes = async (taskGroupId) => {
    try {
      this.taskTypesLoader = true
      let response = await this.get(API_ENDPOINTS.GET_TASK_TYPES_ADMIN, {
        taskGroupId,
      })
      if (response.status) {
        this.taskTypes = response.data
        return [true, response.data]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskTypesLoader = false
    }
  }

  @action.bound
  addTaskTypeLocally = (values) => {
    this.taskTypes = [...this.taskTypes, values]
  }

  @action.bound
  addTaskType = async (values) => {
    try {
      this.taskTypesAddLoader = true
      let response = await this.post(API_ENDPOINTS.ADD_TASK_TYPE, values)
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskTypesAddLoader = false
    }
  }

  @action.bound
  upateTaskTypeLocally = (values) => {
    this.taskTypes = (this.taskTypes || []).map((taskType) => {
      if (taskType.id === values.id) {
        return values
      }
      return taskType
    })
  }

  @action.bound
  updateTaskType = async (id, values) => {
    try {
      this.taskTypesUpdateLoader = true
      let response = await this.post(API_ENDPOINTS.UPDATE_TASK_TYPES, {
        id,
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskTypesUpdateLoader = false
    }
  }

  @action.bound
  deleteTaskTypeLocally = (id) => {
    this.taskTypes = (this.taskTypes || []).filter((taskType) => {
      return taskType?.id !== id
    })
  }

  @action.bound
  deleteTaskType = async (id) => {
    try {
      this.taskTypesDeleteLoader = true
      let response = await this.post(API_ENDPOINTS.DELETE_TASK_TYPES, {
        id,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskTypesDeleteLoader = false
    }
  }

  @action.bound
  getTaskSubTypeByIdLocally = (id) => {
    return (this.taskSubTypes || []).find(
      (taskSubType) => taskSubType?.id === id
    )
  }

  @action.bound
  getTaskSubTypes = async (taskTypeId) => {
    try {
      this.taskSubTypesLoader = true
      let response = await this.get(API_ENDPOINTS.GET_TASK_SUB_TYPES_ADMIN, {
        taskTypeId,
      })
      if (response.status) {
        this.taskSubTypes = response.data
        return [true, response.data]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskSubTypesLoader = false
    }
  }

  @action.bound
  addTaskSubTypeLocally = (values) => {
    this.taskSubTypes = [...this.taskSubTypes, values]
  }

  @action.bound
  addTaskSubType = async (values) => {
    try {
      this.taskSubTypesAddLoader = true
      let response = await this.post(API_ENDPOINTS.ADD_TASK_SUB_TYPES, values)
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskSubTypesAddLoader = false
    }
  }

  @action.bound
  updateTaskSubTypeLocally = (values) => {
    this.taskSubTypes = (this.taskSubTypes || []).map((taskSubType) => {
      if (taskSubType.id === values.id) {
        return values
      }
      return taskSubType
    })
  }

  @action.bound
  updateTaskSubType = async (id, values) => {
    try {
      this.taskSubTypesUpdateLoader = true
      let response = await this.post(API_ENDPOINTS.UPDATE_TASK_SUB_TYPES, {
        id,
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskSubTypesUpdateLoader = false
    }
  }

  @action.bound
  deleteTaskSubTypeLocally = (id) => {
    this.taskSubTypes = (this.taskSubTypes || []).filter((taskSubType) => {
      return taskSubType?.id !== id
    })
  }

  @action.bound
  deleteTaskSubType = async (id) => {
    try {
      this.taskSubTypesDeleteLoader = true
      let response = await this.post(API_ENDPOINTS.DELETE_TASK_SUB_TYPES, {
        id,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskSubTypesDeleteLoader = false
    }
  }

  @action.bound
  resetStore = () => {
    this.taskGroupFoldersWithTaskLoader = false
    this.taskGroupFoldersWithTaskList = []
    this.taskGroupFoldersDropdownList = []
    this.taskGroupsListByFId = []
    this.taskGroupFoldersSearchText = ''
    this.taskGroupFoldersLoader = false
    this.taskGroupFoldersCurrentPage = DEFAULT_PAGE_START
    this.taskGroupFoldersList = []
    this.taskGroupFoldersTotal = 0
    this.taskGroupFolderActionLoader = false
    this.moveTaskGroupByFIdLoader = false
    this.taskGroups = []
    this.taskTypes = []
    this.taskSubTypes = []
    this.taskGroupLoader = false
    this.taskTypesLoader = false
    this.taskSubTypesLoader = false
    this.taskGroupAddLoader = false
    this.taskGroupUpdateLoader = false
    this.taskGroupDeleteLoader = false
    this.taskTypesAddLoader = false
    this.taskTypesUpdateLoader = false
    this.taskTypesDeleteLoader = false
    this.taskSubTypesAddLoader = false
    this.taskSubTypesUpdateLoader = false
    this.taskSubTypesDeleteLoader = false
    this.taskGroupSearchText = ''
  }
}
